<template>
    <div>
        <pagamento-detalhar 
            :pagamento="pagamento"
            :servicos="pagamentosServicos"
            :mostrarTimeLine="exibirTimeline"
        >
            <template slot="footer" slot-scope="data">
                <slot name="footer" v-bind="data"></slot>
                <b-button
                    variant="primary"
                    class="ml-2"
                    @click.stop="mostrarDocumentos = true"
                    v-if="temAcessoDocumentos && !mostrarDocumentos"
                    ><i class="fa fa-paperclip"></i> Documentos</b-button
                >
                <historico
                    class="ml-2"
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    :mostrarBtnHistorico="mostrarBtnHistorico"
                ></historico>
                <btn-certidoes
                    class="ml-2"
                    :pagamento="pagamento"
                    :servicos="pagamentosServicos"
                ></btn-certidoes>
                <b-button
                    variant="primary"
                    class="ml-2 mr-1"
                    @click.stop="mostrarTimeline()"
                >
                    {{ textoBtnTimeline }} Timeline
                </b-button>
                <pagamento-enviar-para-analise
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-2"
                ></pagamento-enviar-para-analise>
                <pagamento-aprovar-reprovar
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-1"
                ></pagamento-aprovar-reprovar>
                <pagamento-aprovar-com-justificativa
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-1"
                ></pagamento-aprovar-com-justificativa>
                <btn-retornar-pagamento
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-1"
                ></btn-retornar-pagamento>
                <pagamento-iniciar-reprovar
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-1"
                ></pagamento-iniciar-reprovar>
                <btn-prioritario
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-2"
                ></btn-prioritario>
                <btn-especial
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-2"
                ></btn-especial>
                <btn-exportar
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                ></btn-exportar>
            </template>
        </pagamento-detalhar>
        <pagamento-documentos
            v-if="temAcessoDocumentos && mostrarDocumentos"
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
            @fecharDocumentos="mostrarDocumentos = false"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
        ></pagamento-documentos>
        <despesas-pagamento
            v-if="pagamento"
            :despesas="pagamento.despesas"
        >
            <template slot="botoes">
                <slot name="despesasBotoes"></slot>
            </template>
            <template slot="despesaAcoes" slot-scope="data">
                <slot name="despesaAcoes" v-bind="data"></slot>
                <btn-to-despesa
                    :despesaId="data.despesaId"
                    :rotaDespesa="rotaDespesa"
                    :temAcessoDetalharDespesa="temAcessoDetalharDespesa"
                ></btn-to-despesa>
                <pagamento-desassociar-despesa
                    :pagamento="pagamento"
                    :pagamentoDespesa="data"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-1"
                ></pagamento-desassociar-despesa>
            </template>
            <template slot="boleto" slot-scope="data">
                <btn-ajustar-boleto
                    :pagamento="pagamento"
                    :despesa="data"
                    @abrirModalBoleto="abrirModalBoleto(data)"
                ></btn-ajustar-boleto>
            </template>
        </despesas-pagamento>
        <pagamento-anexos
            v-if="$temAcessoView('DESP-GERAIS-PAG-ANX-00')" 
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
        ></pagamento-anexos>
        <ajustar-boleto-form
            ref="ajustarBoletoForm"
            :despesaId="ajustarBoletoDespesaId"
            :servicos="despesasServicos"
            @obterPagamentoAtualizado="$emit('obterPagamentoAtualizado')"
        ></ajustar-boleto-form>
    </div>
</template>

<script>
import PagamentoDetalhar from './PagamentoDetalhar'
import DespesasPagamento from '../despesas/DespesasPagamento.vue'
import PagamentoAnexos from './PagamentoAnexos'
import PagamentoDocumentos from './PagamentoDocumentos'
import PagamentoDesassociarDespesa from './PagamentoDesassociarDespesa'
import PagamentoEnviarParaAnalise from './PagamentoEnviarParaAnalise'
import PagamentoAprovarReprovar from './PagamentoAprovarReprovar'
import BtnToDespesa from './BtnToDespesa.vue'
import BtnAjustarBoleto from './BtnAjustarBoleto.vue'
import AjustarBoletoForm from './AjustarBoletoForm.vue'
import Historico from './PagamentoHistorico'
import BtnCertidoes from './BtnCertidoes'
import BtnExportar from './BtnExportar'
import BtnPrioritario from './BtnPrioritario'
import BtnEspecial from './BtnEspecial'
import PagamentoIniciarReprovar from './PagamentoIniciarReprovar'
import BtnRetornarPagamento from './BtnRetornarPagamento'
import PagamentoAprovarComJustificativa from './PagamentoAprovarComJustificativa.vue'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },
        pagamentosServicos: {
            type: Object,
            required: true
        },

        despesasServicos: {
            type: Object,
            default: () => {}
        },

        rotaDespesa: {
            type: String,
            default: () => null
        },

        temAcessoDetalharDespesa: {
            type: Boolean,
            default: () => false
        },

        mostrarBtnHistorico: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            mostrarDocumentos: true,
            ajustarBoletoDespesaId: null,
            textoBtnTimeline: 'Exibir',
            exibirTimeline: false
        }
    },

    methods: {
        obterPagamentoAtualizado() {
            this.$emit('obterPagamentoAtualizado')
        },

        abrirModalBoleto(despesa) {
            this.$refs.ajustarBoletoForm.mostrarModal = true
            this.ajustarBoletoDespesaId = despesa.despesaId
        },

        mostrarTimeline() {
            this.exibirTimeline = !this.exibirTimeline
            if (!this.exibirTimeline) {
                this.textoBtnTimeline = 'Exibir'
            } else {
                this.textoBtnTimeline = 'Ocultar'
            }
        }
    },

    computed: {
        temAcessoDocumentos() {
            return this.$temAcessoView('DESP-GERAIS-PAG-DOC-00')
                && (this.$route.name == 'DespesasGerais_Finalizacao_Pagamentos_Detalhar' 
                   || this.$route.name == 'DespesasGerais_Financeiro_Pagamentos_Detalhar')
        }
    },

    components: {
        PagamentoDetalhar,
        DespesasPagamento,
        PagamentoAnexos,
        PagamentoDesassociarDespesa,
        PagamentoEnviarParaAnalise,
        PagamentoAprovarReprovar,
        BtnToDespesa,
        BtnAjustarBoleto,
        AjustarBoletoForm,
        Historico,
        PagamentoDocumentos,
        BtnCertidoes,
        BtnExportar,
        BtnPrioritario,
        BtnEspecial,
        PagamentoIniciarReprovar,
        BtnRetornarPagamento,
        PagamentoAprovarComJustificativa
    }
}
</script>
